"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLBBoxSwitcher = void 0;
const react_1 = __importDefault(require("react"));
const plb_box_1 = require("../plb-box");
const static_component_1 = require("../static-component");
const PLBBoxSwitcher = (props) => {
    const { plbBoxState, buyboxState, buyboxStylingState, buyboxComponentId } = props;
    const buyboxCombinedState = Object.assign(Object.assign({}, buyboxState), buyboxStylingState);
    return (react_1.default.createElement("div", { "data-cy": 'plb-box-switcher' }, buyboxState ? (react_1.default.createElement(static_component_1.StaticComponent, { id: buyboxComponentId, state: buyboxCombinedState })) : (react_1.default.createElement(plb_box_1.PLBBox, Object.assign({}, plbBoxState)))));
};
exports.PLBBoxSwitcher = PLBBoxSwitcher;
